<template>
    <HamletTable
        ref="table"
        :columns="columns"
        :fetch="fetch"
        @onRowClick="onRowClick"
    >
        <template #header-label>
            {{ $t('Page(PagesCategories):Component(Text):page-label') }}
        </template>

        <template #header-controls>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-0 btn-icon"
                @click="addCategory"
            >
                <feather-icon icon="PlusIcon" />
            </b-button>
        </template>

        <template #cell-actions="data">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                class="mt-0 btn-icon float-right"
                @click.stop="remove(data.item)"
            >
                <feather-icon icon="Trash2Icon" />
            </b-button>
        </template>
    </HamletTable>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import {BButton} from 'bootstrap-vue'
import {PagesApi} from "@core/api";
import HamletTable from "@core/components/common/HamletTable";

export default {
    directives: {Ripple},
    components: {HamletTable, BButton},
    data() {
        return {
            columns: [
                {
                    key: 'id',
                    label: this.$t('Component(Grid):column-id')
                },
                {
                    key: 'title',
                    label: this.$t('Component(Grid):column-name')
                },
                {
                    key: 'actions',
                    label: this.$t('Component(Grid):column-actions')
                }
            ],
        };
    },
    methods: {
        onRowClick(category) {
            this.$router.push({
                name: 'administration-pages-categories-edit',
                params: {
                    id: category.id
                }
            })
        },
        remove(c) {
            PagesApi
                .deleteCategory(c.id)
                .then(() => {
                    this.$refs.table.makeRequest();
                });
        },
        addCategory() {
            this.$router.push({name: 'administration-pages-categories-add'});
        },
        fetch(config, cb) {
            PagesApi.categories(config.page, config.perPage).then(r => {
                cb(r.data.totalItems, r.data.items);
            });
        }
    }
}
</script>
